module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./GetBlessingView.js"));
	}, "GetBlessingView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GetBlessingView!./src/pages/Shop/Home/MemberBirthday/GetBlessing/GetBlessingView.js
// module id = 920
// module chunks = 438